<mat-tab-group (selectedTabChange)="onChange($event)" #tabGroup class="edi-tabs-wrapper" mat-stretch-tabs="false"
  mat-align-tabs="start" [selectedIndex]="0">
  <mat-tab label="Commission Gateway" style="width: 25%;">

    <div class="gateway-tab-container">
      <div id="gateway-main-wraper">
        <div class="col-12 search-ft p-0 mt-3">
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label name="lblGWSrchUnit" class="control-label">Unit Number / Building Name /
                  Address</label>
                <input type="text" class="form-control" name="txtGWSrchUnit" [(ngModel)]="txtGWSrchUnit" maxlength="20"
                  tabindex="1" (keydown.enter)="onKeyEnter()" />
              </div>
            </div>
            <div class="col d-flex align-items-end">
              <div class="form-group">
                <button class="btn btn-primary mr-2" name="btnGWSearch" (click)="getGridDataByFilterSearch()"
                  tabindex="2">
                  Search
                </button>
                <button class="btn btn-outline-primary mr-2" name="btnGWReset" (click)="resetFilters()" tabindex="3">
                  Reset
                </button>
              </div>
              <div id="gridActions" class="ml-auto">
                <label class="mr-2" tabindex="8" name="firmware" *ngIf="isAdmin" (click)="open(firmwareModal)"><span><em
                      class="fas fa-download"></em></span> DIGI Firmware</label>
                <label *ngIf="isRowSelected" class="mr-2" name="lblAsgnGateway" (click)="open(gatewayModal)"
                  tabindex="8"><span><em class="fas fa-wifi"></em></span> Commission Gateway</label>
                <label *ngIf="!isRowSelected" class="mr-2" name="lblEAsgnGateway"
                  title="Select the unit to assign gateway"><span> <em class="fas fa-wifi"></em></span> Commission
                  Gateway</label>
                <label *ngIf="isRowSelected && !gatewayUpdateEnable" class="mr" name="lblAsgnGateway"
                  (click)="open(decommModal)" tabindex="8"><span class="fa-stack fa-sm"><em class="fas fa-wifi fa-stack-2x"></em><em class="fas fa-slash fa-stack-1x"></em></span>
                  Decommission</label>
                <label *ngIf="!isRowSelected" class="mr" name="lblDAsgnGateway"
                  title="Select the unit to decommission gateway"><span class="fa-stack fa-sm"><em class="fas fa-wifi fa-stack-2x"></em><em class="fas fa-slash fa-stack-1x"></em></span>
                  Decommission</label>
                <label *ngIf="isRowSelected && gatewayUpdateEnable" class="mr" name="lblDecGateway"
                  title="Select the gateway commissioned unit to decommission"><span class="fa-stack fa-sm"><em class="fas fa-wifi fa-stack-2x"></em><em class="fas fa-slash fa-stack-1x"></em></span>
                  Decommission</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gateway-grid-wrapper">
        <ag-grid-angular [enableCellTextSelection]="true" class="ag-theme-material gateway-grid-layout"
          [rowData]="rowData" [columnDefs]="columnDefs" [gridOptions]="gridOptions"
          (rowSelected)="onRowSelected($event)">
        </ag-grid-angular>
        <div class="gateway-legend">
          <i class="fa fa-circle cGreen"></i> : Online &nbsp;|
          <i class="fa fa-circle cRed"></i> : Offline
        </div>
      </div>


      <!-- Gateway Modal Popup HTML -->
      <ng-template #gatewayModal let-modal>
        <div class="modal-header">
          <h5 class="modal-title" id="modal-basic-title">Commission Gateway</h5>
          <button type="button" class="close" aria-label="Close" (click)="modalClose()">
            <em class="fas fa-times-circle"></em>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-12 search-ft p-0 mt-0">
            <div class="row" id="divUnitGateway">
              <div class="col-6">
                <div class="form-group">
                  <label name="lblUDGW" class="control-label">Device Using Gateway : {{ unitdeviceGatewayType
                    }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label name="lblGWMlUnitNum" class="control-label">Elevator Unit Number(s)</label>
                  <div style="width: 100%; overflow: auto;max-height: 80px;">
                    <table class="table-ml">
                      <tr>
                        <th id="unitNum">Unit Number</th>
                        <th id="bldName">Building Name</th>
                        <th id="cpiduuid">CP-ID/UUID</th>
                        <th id="cpiduuid2" *ngIf="isDoubleDeck">CP-ID/UUID2</th>
                      </tr>
                      <tr *ngFor="let row of rowSelectedData">
                        <td>{{ row["elevatorUnitNumber"] }}</td>
                        <td>{{ row["buildingName"] }}</td>
                        <td>{{ row["cpidUuid"] }}</td>
                        <td *ngIf="isDoubleDeck">{{ row["cpidUuid2"] }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="isCGW">
              <div class="col-12">
                <div class="form-group">
                  <img src="../assets/images/info.png" class="imgSize imgAlign">&nbsp;
                  <label name="lblCGWInfo" class="control-label infoTextColor">Please make sure Mobiline has SIM
                    inserted and is powered on before commissioning
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label name="lblGWMLType" class="control-label required">Type
                  </label>
                  <select [disabled]="!gatewayUpdateEnable" name="ddGWMLType" class="form-control"
                    (change)="gatewayTypeSelectChanged($event)">
                    <option *ngFor="let type of gatewayTypes" [selected]="type.id === gatewayTypeSelectedId"
                      [value]="type.id">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
                <div class="lblerror" *ngIf="lblErrorGWMLType">
                  {{ this.lblErrorGWMLType }}
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label name="lblGWMlMacAdd" class="control-label required" *ngIf="!isCGW">Gateway Mac Address</label>
                  <label name="lblGWMlMacAdd" class="control-label required" *ngIf="isCGW">Gateway Serial Number</label>
                  <input [disabled]="!gatewayUpdateEnable" type="text" class="form-control" name="txtGWMlMacAdd"
                    [(ngModel)]="txtGWMlMacAdd" maxlength="20" (keyup)="onKeyPress($event)" />
                </div>
                <div class="lblerror" *ngIf="lblErrorGWMLMacAdd">
                  {{ this.lblErrorGWMLMacAdd }}
                </div>
              </div>
              <div class="col" *ngIf="!isCGW">
                <div class="form-group">
                  <label name="lblGWPwd" class="control-label">Gateway Password </label>
                  <input type="password" class="form-control" name="txtGWPwd" [(ngModel)]="txtGWPwd" maxlength="20"
                    (focus)="clearErrorMessages()" />
                </div>
              </div>
              <div class="col" *ngIf="isCGW">
                <div class="form-group">
                  <label name="lblGWMlIccId" class="control-label">Inserted SIM Card ICCID : AT&T</label>
                  <input type="text" class="form-control" name="txtGWMlIccId" [(ngModel)]="txtGWMlIccId" maxlength="20"
                    (focus)="clearErrorMessages()" disabled="true" />
                </div>
              </div>
            </div>
            <div class="row" *ngIf="!isCGW">
              <div class="col">
                <div class="form-group">
                  <label name="lblGWMlIccId" class="control-label">SIM Card ICCID1 : AT&T</label>
                  <input type="text" class="form-control" name="txtGWMlIccId" [(ngModel)]="txtGWMlIccId" maxlength="20"
                    (blur)="onATTDeviceSearch()" [disabled]="!gatewayUpdateEnable && txtGWMlIccId.length === 20" />
                </div>
                <div class="lblerror" *ngIf="lblICCID1error">
                  {{ this.lblICCID1error }}
                </div>
                <div class="lblsuccess" *ngIf="lblICCID1success">
                  {{ this.lblICCID1success }}
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label name="lblGWMlIccId2" class="control-label">SIM Card ICCID2 : Verizon</label>
                  <input type="text" class="form-control" name="txtGWMlIccId2" [(ngModel)]="txtGWMlIccId2"
                    maxlength="20" (blur)="onVerizonDeviceSearch()" [disabled]="!gatewayUpdateEnable && txtGWMlIccId2.length === 20"/>
                </div>
                <div class="lblerror" *ngIf="lblICCID2error">
                  {{ this.lblICCID2error }}
                </div>
                <div class="lblsuccess" *ngIf="lblICCID2success">
                  {{ this.lblICCID2success }}
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label name="lblGWMlMacAdd" class="control-label">Otis ONE Compatible Firmware</label>
                  <select name="ddOOCVersion" class="form-control" (change)="fmOOCVersionSelectChanged($event)">
                    <option *ngFor="let type of TempTxtGMfwVersion.split(',')">
                      {{type}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="!isCGW">
              <div class="col">
                <div class="form-group">
                  <label name="lblSuggestedVersion" class="control-label">Running Firmware Version
                    from DRM </label>
                  <input type="text" disabled="true" class="form-control" name="txtSuggestedVersion"
                    [(ngModel)]="txtSuggestedVersion" maxlength="15" />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label name="lblSuggestedVersion" class="control-label">Firmware Installation Progress
                    &nbsp;&nbsp;<img src="../assets/images/info.png" class="imgSize"
                      title="The installation of the firmware may require approximately 5 minutes">
                  </label>
                  <div class="firmware-section">
                    <mat-progress-bar [mode]="'determinate'" [value]="progress" class="progressStyle">
                    </mat-progress-bar>
                    <label name="lblProgress" class="control-label percentageStyle">{{progress}}%</label>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                </div>
              </div>
            </div>
            <div class="row" *ngIf="isCGW">
              <div class="col">
                <div class="form-group" *ngIf="lblG3MSErrorMessage" [ngClass]="'redlabel'">
                  <label name="lblmessage">{{ lblG3MSErrorMessage }}</label>
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                </div>
              </div>
              <div class="col">
                <div class="form-group" *ngIf="lblConnectionStatus">
                  <label name="lblmessage">{{ lblConnectionStatus }}</label>
                  <div *ngIf="isOnline">
                    <i class='fa fa-circle cGreen'></i>
                    <label name="lblmessage" [ngClass]="'greenlabel'">Connected</label>
                  </div>
                  <div *ngIf="!isOnline">
                    <i class='fa fa-circle cRed'></i>
                    <label name="lblmessage" [ngClass]="'redlabel'">Disconnected</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group" *ngIf="lblVersionMessage" [ngClass]="isBtnEndGateway ? 'greenlabel' : 'redlabel'">
                <label name="lblmessage">{{ lblVersionMessage }}</label>
              </div>
            </div>
             <div class="row">
               <div class="form-group" *ngIf="lblATTStatus" [ngClass]="isATTActivation ? 'greenlabel' : 'redlabel'">
                <label name="lblATTMessage">{{ lblATTStatus }}</label>
              </div>
            </div>
            <div class="row">
              <div class="form-group" *ngIf="lblVerizonStatus" [ngClass]="isVerizonActivation ? 'greenlabel' : 'redlabel'">
                <label name="lblmessage">{{ lblVerizonStatus }}</label>
              </div>             
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div *ngIf="!isCGW">
            <button type="button" class="btn btn-primary mr-2" (click)="onAssignGateway($event)">
              Commission Gateway
            </button>
          </div>
          <div *ngIf="isCGW">
            <button type="button" class="btn btn-primary mr-2" (click)="onAssignGateway($event)"
              [disabled]="!gatewayUpdateEnable || !isValidSerialNumber">
              Commission Gateway
            </button>
          </div>
          <button *ngIf="!isCGW" type="button" class="btn btn-primary mr-2" (click)="onUpdateFirmware($event)"
            [disabled]="gatewayUpdateEnable">
            Get Firmware Version
          </button>
          <button *ngIf="isCGW" type="button" class="btn btn-primary mr-2" (click)="getCGWConnectionStatus()">
            Get Connection Status
          </button>
          <button *ngIf="!isCGW" type="button" class="btn btn-primary mr-2" (click)="onUpdateFirmwareinDRM($event)"
            [disabled]="gatewayUpdateEnable">
            Update Firmware in DRM
          </button>
          <button type="button" class="btn btn-outline-primary mr-2" (click)="modalClose()">
            Close
          </button>
        </div>
      </ng-template>

      <!-- Decommission Modal Popup HTML -->
      <ng-template #decommModal let-modal>
        <div class="modal-header">
          <h5 class="modal-title" id="modal-basic-title">Gateway Decommission</h5>
          <button type="button" class="close" aria-label="Close" (click)="modalClose()">
            <em class="fas fa-times-circle"></em>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-12 search-ft p-2 mt-3">
            <div class="row">
              <div class="col">
                <div class="form-group">
                  Are you sure want to Gateway Decommission for the selected Unit
                  ..?
                  <p class="text-style"></p>
                  <p class="text-style">
                    Unit Number : {{ rowSelectedData[0]["elevatorUnitNumber"] }}
                  </p>
                  <p class="text-style">
                    CP-ID/UUID : {{ rowSelectedData[0]["cpidUuid"] }}
                  </p>
                  <p class="text-style" *ngIf="isDoubleDeck">
                    CP-ID/UUID2 : {{ rowSelectedData[0]["cpidUuid2"] }}
                  </p>
                  <p class="text-style">
                    Device Using Gateway :
                    {{ unitdeviceGatewayType }}
                  </p>
                  <p class="text-style" *ngIf="!isCGW">
                    Gateway Mac Address :
                    {{ rowSelectedData[0]["gatewayMacAddress"] }}
                  </p>
                  <p class="text-style" *ngIf="isCGW">
                    Gateway Serial Number :
                    {{ rowSelectedData[0]["gatewayMacAddress"] }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" name="btnUMMLYes" class="btn btn-primary mr-2" (click)="OnDecommissioinGateway()">
            Decommission
          </button>
          <button type="button" name="btnUMMLNo" class="btn btn-outline-primary mr-2" (click)="modalClose()">
            Close
          </button>
        </div>
      </ng-template>

      <!-- Firm ware Modal Popup HTML -->
      <ng-template #firmwareModal let-modal>
        <div class="modal-header">
          <h5 class="modal-title" id="modal-basic-title">DIGI Firmware</h5>
          <button type="button" class="close" aria-label="Close" (click)="modalClose(true)">
            <em class="fas fa-times-circle"></em>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-12 search-ft p-0 mt-6">
            <div class="row">
              <div class="col">
                <label name="lblGWMlUnitNum" class="control-label">Current Firmware Versions</label>
                <div style="width: 100%; overflow: auto">
                  <table class="table-ml">
                    <tr>
                      <th id="unitNum">Gateway Type</th>
                      <th id="bldName">Firmware Version 1</th>
                      <th id="bldName">Firmware Version 2</th>
                      <th id="bldName">Created By</th>
                    </tr>
                    <tr *ngFor="let row of gatewayTypes">
                      <td>{{ row.name }}</td>
                      <ng-container *ngFor="let fmv of GWFMVersion">
                        <td *ngIf="fmv.gatewayTypeId == row.id">{{fmv.firmwareVersion.split(',')[0]}}</td>
                        <td *ngIf="fmv.gatewayTypeId == row.id">{{fmv.firmwareVersion.split(',')[1]}}</td>
                        <td *ngIf="fmv.gatewayTypeId == row.id">{{fmv.createdBy}}</td>
                      </ng-container>
                    </tr>
                  </table>
                  <br>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label name="lblGWMlMacAdd" class="control-label required">New Firmware
                    Version</label>
                  <input type="text" class="form-control" name="txtGWFirmwareVersion" [(ngModel)]="txtGWFirmwareVersion"
                    maxlength="32" (focus)="clearErrorMessages()" />
                </div>
                <div class="lblerror" *ngIf="lblErrorGWFWVersionAdd">
                  {{ this.lblErrorGWFWVersionAdd }}
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label name="lblGWMLType" class="control-label required">Type
                  </label>
                  <select name="ddGWMLType" class="form-control" (change)="fmGatewayTypeSelectChanged($event)">
                    <option *ngFor="let type of gatewayTypes" [value]="type.id"
                      [selected]="type.id === gatewayTypeSelectedId">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary mr-2" (click)="gatewayFirmwareSubmit()">
            Submit
          </button>
          <button type="button" class="btn btn-outline-primary mr-2" (click)="modalClose(true)">
            Close
          </button>
        </div>
      </ng-template>
    </div>
  </mat-tab>
  <mat-tab label={{gatewaySync}} *ngIf="enableGatewaySync" [disabled]="!enableGatewaySync" style="width: 25%;">
    <app-gateway-info></app-gateway-info>
  </mat-tab>
  <mat-tab [disabled]=true></mat-tab>
  <mat-tab [disabled]=true></mat-tab>
</mat-tab-group>
